export const CREDENTIAL_TYPES = ["ALL", "ENTITY", "VENUE"] as const;

export type CredentialType = (typeof CREDENTIAL_TYPES)[number];

export interface Credential {
  credentialId: string;
  sport: string;
  organizationId: string;
  name: string;
  username: string;
  credentialType: CredentialType;
  startDate: string;
  expiryDate: string;
  ids: string[];
  competitions: string[];
  permissions: Record<string, unknown>;
}

export interface CreateCredentialPayload {
  name: string;
  username: string;
  password: string;
  credentialType: CredentialType;
  startDate: string;
  expiryDate: string;
  competitions?: string[];
  ids?: string[];
}

export interface UpdateCredentialPayload {
  name: string;
  startDate: string;
  expiryDate: string;
  competitions: string[];
  ids: string[];
  permissions: Record<string, unknown>;
  password?: string;
}
